function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1593.9,56C1579.6,56-0.2,56-0.2,56L0,30.9c73.3-19.1,135.5-62.8,317.1,24.5C409.5-8.6,569.8-9.3,674,41.1 c83.1-20.5,152.6-21.8,220.7-4.1c67-21.8,136.7-8.2,172.2,14.8c62.1-33.5,187.9-54.1,267.2-14.4l0,0c74-43.2,209.1-46.7,260-22.2 L1593.9,56z"
});

var SvgCloudDivider = function SvgCloudDivider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1594.1 56",
    fill: "var(--ds-color-background-app)",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloudDivider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloudDivider.1cf16216.svg";
export { ForwardRef as ReactComponent };